// Auto-generated skeleton for BuildingType

export const BuildingType: Api.BuildingType = {
  id: 0,
  type_rule: '',
  acronym: '',
  name: '',
  created: null,
  updated: null,
};

